import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Props from './ConfirmationReservationInfoComponent';
import Translation from "../../../../shared/Translation";
import { connect } from 'react-redux';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import ViewTicketsButton from '../../../components/ViewTicketsButton';

class ConfirmationReservationInfo extends Component<Props> {

    getMessage = () => {

        if (!this.props.showTooltip) {
            return <div>
                        <Translation interpolation={{email: this.props.email, boldStart:"<strong>", boldEnd:"</strong>"}}>
                            {this.props.pending ? 'checkout__confirm_email_pending_state' : 'checkout__confirm_email_sent'}
                        </Translation>
                    </div>;
        } else {
            return <div>
                        <Translation interpolation={{email: this.props.email, boldStart:"<strong>", boldEnd:"</strong>"}}>
                            {this.props.pending ? 'checkout__confirmation_email_pending_state' : 'checkout__confirmation_email_sent'}
                        </Translation>
                        <Tippy
                            content="Confirmation message updates based on delivery method selected"
                            arrow={true}
                            placement="right"
                            trigger="mouseenter"
                            theme="light-border"
                            interactive="true"> 
                            <i class="icon-info" aria-hidden="true"></i>
                        </Tippy>

                    </div>
        }
    }

    render() {
        return (
            <div className="confirmation-reservation">
                    {!!this.props.confirmationNumber && !this.props.pending && this.props.showTooltip &&  <div className="confirmation-reservation__id">
                    <Translation interpolation={{confirmationId:this.props.confirmationNumber}}>{'checkout__confirmation_id'}</Translation>
                </div>}
                <div className="confirmation-reservation__delivery">
                    {this.getMessage()}
                </div>
                {!this.props.pending && this.props.ticketsUrl && <ViewTicketsButton url={this.props.ticketsUrl} />}
            </div>
        )
    }
}

ConfirmationReservationInfo.propTypes = {
    confirmationNumber: PropTypes.string,
    email: PropTypes.string,
    pending: PropTypes.bool,
    showTooltip: PropTypes.bool,
}

const mapStateToProps = (state) => {
    return {
        selectedOption: state.hasOwnProperty("reservation") ? state.confirmation.deliveryMethodName: "Print at Home",
    }
}

export default connect(mapStateToProps)(ConfirmationReservationInfo);